import { types as ActionTypes, asyncEvents as AsyncEvents } from './Consents.actions';

import { combineReducers } from 'redux';
import { resultsReducers } from '../../../common/helpers/ReduxHelpers';

const emptyArray = [];
const emptyObject = {};

export const initialState = {
    results: emptyArray,
    resultCount: 0,
    error: null,
    loading: false,
    nextPage: null,
    pageNumber: 1,
    planData: emptyObject,
};

export default combineReducers({
    ...resultsReducers(
        initialState,
        Object.keys(AsyncEvents).map(key => ActionTypes[key])
    ),
});
